import Element from './element-plus/';
import Data from './data/';
export default { ...Element, ...Data };
